import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import * as T from './actionTypes';
import {
  fetchContractorCostSuccess, fetchContractorCostFail,
  createContractorCostSuccess, createContractorCostFail,
  updateContractorCostSuccess, updateContractorCostFail,
  deleteContractorCostSuccess, deleteContractorCostFail,
  fetchWorkOrderCostSuccess, fetchWorkOrderCostFail,
} from './actions';

const errMsg = (e, fallback) => e?.response?.data?.message || fallback;

function* fetchContractorCostSaga({ payload: workOrderId }) {
  try {
    const { data } = yield call(api.get, `work-order-contractor-cost?workOrderId=${workOrderId}`);
    yield put(fetchContractorCostSuccess(data.response));
  } catch (error) {
    yield put(fetchContractorCostFail(errMsg(error, 'Failed to load contractor cost')));
  }
}

function* createContractorCostSaga({ payload: { data: payload, callback } }) {
  try {
    const { data } = yield call(api.post, 'work-order-contractor-cost', payload);
    yield put(createContractorCostSuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const m = errMsg(error, 'Failed to add contractor cost');
    yield put(createContractorCostFail(m));
    if (callback) callback(m);
  }
}

function* updateContractorCostSaga({ payload: { id, data: payload, callback } }) {
  try {
    const { data } = yield call(api.put, `work-order-contractor-cost?id=${id}`, payload);
    yield put(updateContractorCostSuccess(data.response));
    if (callback) callback(null, data.response);
  } catch (error) {
    const m = errMsg(error, 'Failed to update contractor cost');
    yield put(updateContractorCostFail(m));
    if (callback) callback(m);
  }
}

function* deleteContractorCostSaga({ payload: { id, callback } }) {
  try {
    yield call(api.delete, `work-order-contractor-cost?id=${id}`);
    yield put(deleteContractorCostSuccess(id));
    if (callback) callback(null, id);
  } catch (error) {
    const m = errMsg(error, 'Failed to delete contractor cost');
    yield put(deleteContractorCostFail(m));
    if (callback) callback(m);
  }
}

function* fetchWorkOrderCostSaga({ payload: workOrderId }) {
  try {
    const { data } = yield call(api.get, `work-order-cost?workOrderId=${workOrderId}`);
    yield put(fetchWorkOrderCostSuccess(data.response));
  } catch (error) {
    yield put(fetchWorkOrderCostFail(errMsg(error, 'Failed to load work order cost')));
  }
}

export default function* workOrderCostSaga() {
  yield takeLatest(T.FETCH_CONTRACTOR_COST, fetchContractorCostSaga);
  yield takeLatest(T.CREATE_CONTRACTOR_COST, createContractorCostSaga);
  yield takeLatest(T.UPDATE_CONTRACTOR_COST, updateContractorCostSaga);
  yield takeLatest(T.DELETE_CONTRACTOR_COST, deleteContractorCostSaga);
  yield takeLatest(T.FETCH_WORK_ORDER_COST, fetchWorkOrderCostSaga);
}
